import PermissionModal from './PermissionModal';

export default PermissionModal;
